<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table data-id="widgetPropertyAnalysis" class="widget-large-widgetPropertyAnalysis widgetPropertyAnalysis cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-PropertyAnalysis">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tr class="emptyRow"><td colspan="33">&nbsp;</td></tr>
    <tr class="propertyAnalysisChartArea">
      <td colspan="33" style="height: 300px; width:400px;">
        <table class="widget-large-propertyanalysis" aria-hidden="true">
          <thead>
            <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent-propertyanalysis">
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-space">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
            </tr>
          </thead>
          <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent-propertyanalysis">
            <td colspan="33"><widget-label [widget]="this" [fieldName]="'labelWaltText'" [align]="'left'"></widget-label></td>
          </tr>
          <tr *ngIf="chartsReady">
            <td colspan="16" class="widget-left-chart">
              <div class="k-donut-chart-container-print-fix" style="height: 400px; width:487px;">
                <div class="k-donut-chart-wrapper">
                  <kendo-chart class="k-donut-chart-area report-designer-chart-property-cash-flow" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
                    <kendo-chart-title [text]="('incomeAnalysis.labelLeaseExpiry' | rdTranslate)" font="16px Arial"></kendo-chart-title>
                    <kendo-chart-area background="none"></kendo-chart-area>
                    <kendo-chart-value-axis>
                      <kendo-chart-value-axis-item [title]="{ text: (('incomeAnalysis.labelNla' | rdTranslate) + ' (' +unitOfArea + ')' ), font: '12px Arial' }" name="first" font="12px Arial">
                        <kendo-chart-value-axis-item-labels font="12px Arial"></kendo-chart-value-axis-item-labels>
                        <kendo-chart-value-axis-item-title font="12px Arial"></kendo-chart-value-axis-item-title>
                      </kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-category-axis>
                      <kendo-chart-axis-defaults>
                        <kendo-chart-axis-defaults-labels format="n0">
                        </kendo-chart-axis-defaults-labels>
                      </kendo-chart-axis-defaults>
                      <kendo-chart-category-axis-item [categories]="categories" [axisCrossingValue]="[0, categories.length]" [justified]="true">
                        <kendo-chart-category-axis-item-labels font="12px Arial"></kendo-chart-category-axis-item-labels>
                      </kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>
                    <kendo-chart-series>
                      <kendo-chart-series-item *ngFor="let item of seriesLeaseExpiry; let i = index;" type="column" [name]="item.name" [color]="item.color" [stack]="true"
                                               [data]="item.data">
                      </kendo-chart-series-item>
                    </kendo-chart-series>
                    <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal">
                    </kendo-chart-legend>
                  </kendo-chart>
                </div>
              </div>
            </td>
            <td colspan="1" class="small-space">&nbsp;</td>
            <td colspan="16" class="widget-right-chart">
              <div class="k-donut-chart-container-print-fix" style="height: 400px; width:487px;">
                <div class="k-donut-chart-wrapper">
                  <kendo-chart class="k-donut-chart-area report-designer-chart-property-cash-flow" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
                    <kendo-chart-title [text]="('incomeAnalysis.labelTenancyProfile' | rdTranslate)" font="16px Arial"></kendo-chart-title>
                    <kendo-chart-area background="none"></kendo-chart-area>
                    <kendo-chart-value-axis>
                      <kendo-chart-value-axis-item font="12px Arial">
                        <kendo-chart-value-axis-item-title font="12px Arial"></kendo-chart-value-axis-item-title>
                        <kendo-chart-value-axis-item-labels font="12px Arial"></kendo-chart-value-axis-item-labels>
                      </kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-category-axis>
                      <kendo-chart-axis-defaults>
                        <kendo-chart-axis-defaults-labels format="n0">
                        </kendo-chart-axis-defaults-labels>
                      </kendo-chart-axis-defaults>
                      <kendo-chart-category-axis-item [categories]="categories" [axisCrossingValue]="[0, categories.length]" [justified]="true">
                        <kendo-chart-category-axis-item-labels font="12px Arial"></kendo-chart-category-axis-item-labels>
                      </kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>
                    <kendo-chart-series>
                      <kendo-chart-series-item *ngFor="let item of seriesTenancyProfile; let i = index;" type="area" [name]="item.name" [color]="item.color"
                                               [data]="item.data">
                      </kendo-chart-series-item>
                      <kendo-chart-series-item *ngFor="let item of seriesTenancyProfileLine; let i = index;" type="line" [name]="item.name" [color]="item.color"
                                               [data]="item.data">
                      </kendo-chart-series-item>
                    </kendo-chart-series>
                    <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal">
                    </kendo-chart-legend>
                  </kendo-chart>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
